export const formatTitleToId = (title: string) => {
  const result = title?.toLowerCase().split(/\W+/).join('-')
  return result?.endsWith('-') ? result?.slice(0, -1) : result
}
